import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class OrganisationstatisticsService {
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + "/common"
  scrollHeight: string = '22em';
  constructor(private httpClient: HttpClient, private route: Router) {

  }

  orgStatsDataExcel() {
    return this.httpClient.get(`${this.baseURL}/orgstats/orgstatsdataexcel`, { responseType: 'blob' });
  }
}
